import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import CarOrderReservationsTable from './CarOrderReservationsTable';


const styles = ({
  paddingBorder: {
    padding: '0px 240px',
    borderBottom: '2px solid #007b7a'
  },
  group: {
    display: 'inline-block'
  },
  radioSize: {
    height: '24px',
    width: '24px',
    margin: '2px 4px 2px 8px'
  }
});


class CarOrderReservationsPersonal extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      reservationFilterValue: 'sameCharacteristics'
    }
  }

  handleFilterData = event => {
    this.setState({ reservationFilterValue: event.target.value });
  };

  handleCheckReservation = (id, customer) => {
    this.props.handleCheckReservation(id, customer);
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Grid container justify='center'>
              <Grid item className={classes.paddingBorder}>
                <FormControl component='fieldset' >
                  <RadioGroup
                    name='reservationFilterValue'
                    className={classes.group}
                    value={this.state.reservationFilterValue}
                    onChange={this.handleFilterData}
                  >
                    <FormControlLabel name='sameCharacteristics' value='sameCharacteristics' control={<Radio classes={{ root: classes.radioSize }} color='primary' />} label='MESMAS CARACTERÍSTICAS' />
                    <FormControlLabel name='allReservations' value='allReservations' control={<Radio classes={{ root: classes.radioSize }} color='primary' />} label='TODAS' />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CarOrderReservationsTable reservationFilterValue={this.state.reservationFilterValue} handleCheckReservation={this.handleCheckReservation.bind(this)} carBrandModel={this.props.carBrandModel} carDetail={this.props.carDetail} />
      </div>
    );
  }
};

CarOrderReservationsPersonal.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CarOrderReservationsPersonal);


// WEBPACK FOOTER //
// ./src/components/FirmPurchases/CarsList/CarOrdering/CarOrderReservationsPersonal.js